import { Accordion } from "@/components/ui/accordion";
import type { QuizQuestion } from "@/types/quiz";
import type { ScoringRule } from "@/types/scoring-rules";
import type { DraftRule, DraftRuleAggregate } from "./types";
import { QuestionGroup } from "./QuestionGroup";

interface ScoringRulesListProps {
  questions: QuizQuestion[];
  availableTags: string[];
  openItems: string[];
  onOpenItemsChange: (items: string[]) => void;
  getDraftsForAnswer: (answerId: string) => DraftRule[];
  isDirtyForAnswer: (answerId: string) => boolean;
  updateAggregate: (
    answerId: string,
    aggregateId: string,
    updated: DraftRuleAggregate,
  ) => void;
  removeAggregate: (answerId: string, aggregateId: string) => void;
  addDraft: (answerId: string) => void;
  quizId?: string;
  rules?: ScoringRule[];
}

export function ScoringRulesList({
  questions,
  availableTags,
  openItems,
  onOpenItemsChange,
  getDraftsForAnswer,
  isDirtyForAnswer,
  updateAggregate,
  removeAggregate,
  addDraft,
  quizId,
  rules,
}: ScoringRulesListProps) {
  const allQuestionKeys = questions.map((q) => q.questionKey);
  return (
    <Accordion
      type="multiple"
      value={openItems}
      onValueChange={onOpenItemsChange}
      className="space-y-2"
    >
      {questions.map((question, qIndex) => (
        <QuestionGroup
          key={question.questionKey}
          question={question}
          questionIndex={qIndex}
          availableTags={availableTags}
          getDraftsForAnswer={getDraftsForAnswer}
          isDirtyForAnswer={isDirtyForAnswer}
          updateAggregate={updateAggregate}
          removeAggregate={removeAggregate}
          addDraft={addDraft}
          quizId={quizId}
          allQuestionKeys={quizId ? allQuestionKeys : undefined}
          affectedRulesCount={
            rules
              ? rules.filter((r) => r.questionId === question.questionKey).length
              : undefined
          }
        />
      ))}
    </Accordion>
  );
}
